<template>
  <div v-if="videoCount > 0" class="videos">
    <div
      v-for="(productVideo, index) in videos"
      :key="productVideo.video_id || productVideo.id || index"
    >
      <div
        class="video-responsive"
        v-html="prepareVideo(productVideo.code || productVideo.platform?.code, productVideo.video_id)"
      ></div>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue';

const props = defineProps({
  videos: {
    type: Array,
    required: true,
  },
});

const videoCount = computed(() => props.videos.length);

const prepareVideo = (code, video_id) => {
  if (!code || !video_id) return '';
  return String(code).replace('[[video_id]]', video_id);
};
</script>
<style scoped>
.video-responsive {
  position: relative;
  display: block;
  width: 100%;
  max-width: 850px;
  overflow: hidden;
  padding-top: 20px;
  margin: 0 auto;
}

.video-responsive::before {
  display: block;
  content: "";
  padding-top: 56.25%;
}

.video-responsive :deep(iframe) {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
